module.exports = __webpack_public_path__ + "img/chrome.d60a042e.svg";